import { Dialog } from "primereact/dialog";
import { InvoiceSummaryService } from "../InvoiceSummaryService";
import { useEffect, useState } from "react";
import { LoadingService } from "../../../../AppLoading";
import { useTranslation } from "../../../../shared/language";

interface ViewSummaryDialogProps {
  open: boolean;
  onHide: (open: boolean) => void;
  data: any;
}

export const ViewSummaryDialog = ({
  open,
  onHide,
  data,
}: ViewSummaryDialogProps) => {
  const { t } = useTranslation();
  const [pdfSrc, setPdfSrc] = useState("");

  useEffect(() => {
    if (data?.id && open) {
      setPdfSrc(InvoiceSummaryService.getInvoiceSummaryPdfUrl(data.id));
    }
  }, [open, data]);

  const onIframeLoad = () => {
    LoadingService.stop();
  };

  return (
    <Dialog
      visible={open}
      style={{ width: "100%", maxWidth: "1600px" }}
      header={t("common.printView")}
      modal
      onHide={() => onHide(false)}
    >
      {pdfSrc && (
        <iframe
          src={pdfSrc}
          style={{
            width: "100%",
            height: "80vh",
            border: "none",
          }}
          title={t("report.summaryDetails")}
          onLoad={onIframeLoad}
        />
      )}
    </Dialog>
  );
};
